export default __webpack_public_path__ + "static/media/family.ebc1760c.png";